import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { usePlayer } from "../context/PlayerContext";
import ShareButton from "./ShareButton";

function fmt(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-US", { month: "short", year: "numeric" });
  } catch {
    return d;
  }
}

export default function ReleaseCard({ release, index = 0 }) {
  const { playRelease } = usePlayer();
  const isAlbum = release.releaseType === "album" || release.releaseType === "ep";
  const to = `/music/${release.slug}`;

  return (
    <motion.div
      data-testid={`release-card-${release.slug}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group overflow-hidden rounded-3xl border border-white/10 bg-surface/60"
    >
      <div className="relative aspect-square overflow-hidden">
        <Link to={to}>
          <img
            src={release.artwork}
            alt={`${release.title} cover`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </Link>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
        {release.isNew && (
          <span className="absolute left-3 top-3 rounded-full bg-gold px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-black">
            New
          </span>
        )}
        <button
          data-testid={`play-${release.slug}`}
          onClick={() => playRelease(release)}
          aria-label={`Play ${release.title}`}
          className="absolute bottom-3 right-3 flex h-12 w-12 items-center justify-center rounded-full bg-gold text-black shadow-lg transition-transform active:scale-90 hover:scale-110"
        >
          <Play size={18} fill="currentColor" className="ml-0.5" />
        </button>
      </div>
      <div className="p-4">
        <div className="mb-1 flex items-center justify-between gap-2">
          <span className="text-[10px] font-semibold uppercase tracking-widest text-gold">
            {release.releaseType}
          </span>
          <span className="text-[10px] uppercase tracking-widest text-white/40">{fmt(release.releaseDate)}</span>
        </div>
        <Link to={to}>
          <h3 className="truncate font-display text-lg font-semibold text-white transition-colors hover:text-gold">
            {release.title}
          </h3>
        </Link>
        <p className="mb-3 text-xs text-white/50">DJ Código</p>
        <div className="flex items-center justify-between">
          <Link
            to={to}
            className="text-[11px] font-semibold uppercase tracking-wide text-white/60 underline underline-offset-4 hover:text-gold"
          >
            {isAlbum ? "View Album" : "View"}
          </Link>
          <ShareButton release={release} className="!px-3 !py-1.5" />
        </div>
      </div>
    </motion.div>
  );
}
